import { ActionTypes as action } from "./action-types";
import { initialState } from './state';

const mutations = {
    [action.GET_PEOPLE_LIST](state, data) {
        state.peopleList = data;
    },

    [action.GET_USER_LIST](state, data) {
        state.userList = data;
    },
    [action.GET_PEOPLE_BY_ID](state, data) {
        state.peopleDetails = data;
    },
    [action.SET_PEOPLE_ORDER](state, data) {
        state.peopleSortableList = data;
    },
    [action.SET_SELECTED_VIEW](state, view) {
        state.selectedView = view;
    },
    [action.RESET_STATE](state) {
        Object.assign(state, initialState);
    },
};

export default mutations;
